import Billing from 'components/global/Billing';

const VCBilling = () => <Billing />;

export default VCBilling;
